<template>
  <div>
    <top-header v-bind:title="$t('trainees')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-bind:label="$t('add')"
                     v-bind:to="{ name: 'learning-trainee-add' }" />
    </top-header>
    <v-container>
      <trainee-table-card item-route-name="learning-trainee"
                          v-bind:loading="loading"
                          v-bind:trainees="trainees" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import TraineeTableCard from '@/components/learning/TraineeTableCard.vue'

  export default {
    components: {
      HeaderButton,
      TopHeader,
      TraineeTableCard
    },
    computed: {
      ...mapGetters({
        trainees: 'learning/trainees'
      })
    },
    async created() {
      this.loading = true

      await this.loadCategories()
      await this.loadDepartments()
      await this.loadLearningTenants()
      await this.loadTrainees()

      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      ...mapActions({
        loadDepartments: 'common/loadDepartments',
        loadTrainees: 'learning/loadTrainees',
        loadLearningTenants: 'learning/loadLearningTenants',
        loadCategories: 'learning/loadCategories',
        loadLearningTenants: 'learning/loadLearningTenants'
      })
    },
    name: 'Trainees'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Neu",
      "trainees": "Trainees"
    },
    "en": {
      "add": "Add",
      "trainees": "Trainees"
    }
  }
</i18n>